<template>
  <v-layout justify-center mb-3 id="connectionWarning">
    <v-flex xs12 sm8 md8>
      <v-card class="elevation-12">
        <v-container class="warning-card">
          <img width="48" height="48" src="@/assets/art/Upload Warning Solid.svg">
          <div class="title font-weight-bold">
            {{ $t('webTransfer.slowConnection') }}
          </div>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ConnectionWarning'
}
</script>

<style scoped>
.warning-card {
  background-color: #FFC220;
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
